/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-08-05",
    versionChannel: "nightly",
    buildDate: "2023-08-05T00:19:09.531Z",
    commitHash: "f75b36a32a9cc1f1b99ed168107738218d7dabb3",
};
